export default "__VITE_ASSET__BCWJ_M3U__"